import { tax_id_types } from 'lib/constants/constants';

const getInitialValues = (item, practice) => ({
  id: item?.id || null,
  practice_id: item?.practice_id || practice?.id || null,
  bill_name: item?.bill_name || practice?.name || '',
  bill_npi: item?.bill_npi || '',
  bill_taxid: item?.bill_taxid || '',
  bill_taxid_type: tax_id_types?.find((type) => type?.value == item?.bill_taxid_type) || '',
  bill_taxonomy: item?.bill_taxonomy || '',
  bill_id: item?.bill_id || '',
  bill_addr_1: item?.bill_addr_1 || practice?.practiceAddress?.address_ln_1 || '',
  bill_addr_2: item?.bill_addr_2 || practice?.practiceAddress?.address_ln_2 || '',
  bill_city: item?.bill_city || practice?.practiceAddress?.city || '',
  bill_state: item?.bill_state || practice?.practiceAddress?.state || '',
  bill_zip: item?.bill_zip || practice?.practiceAddress?.zip?.replace(/-/g, '') || '',
  bill_phone: item?.bill_phone || practice?.phone || ' ',
  practitioner_ids: item?.practitioner_ids || []
});

export default getInitialValues;
